export abstract class DgComponentMapModule {

  public abstract getDgComponentByTypeName(componentTypeName: string): any;
}
